import React, { Component, useEffect, useState } from 'react';
import { withRouter, Link, Redirect } from "react-router-dom";
import Page from "../../utils/Page";
import { BASE_URL, SITE_INFO_EMAIL } from '../../utils/constants';
import "./PaymentSuccess.scss";
import RenderHTML from '../../utils/RenderHtml';
import TopBanner from '../../components/TopBanner/TopBanner';
import Header from '../../components/Header/Header';
import { useGoondrookSiteData } from '../../utils/dataContext';

const testItems = [
  {
    "name": "Salange Mini LED Portable Projector",
    "id": "salange-mini-led-portable-projector",
    "stock": 2755,
    "actual price": 52.5,
    "price": 91.87,
    "rrp": 129.53,
    "topBanner": "true",
    "popular now": "true",
    "item": "Salange Mini LED Portable Projector",
    "description": "Salange J9Pro Mini Projector LED Home Media Player Audio Portable Proyectors 480x360 Pixels Supports 1080P HDMI USB Video Beamer",
    "descriptionHtmlSort": "Salange J9Pro Mini Projector LED Home Media Player Audio Portable Proyectors 480x360 Pixels Supports 1080P HDMI USB Video Beamer",
    "descriptionHtmlLong": "<div>\n  <h1    style=\"font-family:&quot;Open Sans&quot;, Roboto, Arial, Helvetica, sans-serif, SimSun;font-size:14px;font-weight:500;letter-spacing:normal;line-height:19px;text-align:start;white-space:normal;color:rgb(34, 34, 34);background-color:rgb(255, 255, 255);margin:0px;margin-bottom:0px;margin-top:0px;margin-left:0px;margin-right:0px;width:fit-content;box-sizing:border-box\"    class=\"product-title-text\" align=\"start\"><strong><span        style=\"font-size:20px;font-family:arial, helvetica, sans-serif\">Salange J9/J9Pro Mini Projector LED Home Media        Player Audio Portable Proyectors 480x360 Pixels Supports 1080P HDMI USB Video Beamer</span></strong></h1>  <p><br></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\"><strong>Description:</strong></span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Brand:Salange</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Lumens:1000 Lumens</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Resolution:480*360</span><span      style=\"font-size:20px;font-family:arial, helvetica, sans-serif\">Pixels</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Support 1080P decoding,access to clearer      images and more realistic color videos</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Type:home,portable projector,entertainment      projector</span></p>  <p><br></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">-Up to 80 inch Screen Size</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Cater to diversified demands, enjoy large      screen even in small room</span></p>  <p><br></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\"><strong>Product Detail：</strong></span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Light source:LED</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Interface:USB/HD/TYPE      C/AV/DC/IR/HEADEST</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Picture Formats:JPEG/BMP/PNG</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">VideoFormats:SDTV (480i, 576i) / EDTV (480p,      576p) / HDTV (720p, 1080i, 1080p), NTSC (M, 3.58/4.43 MHz), PAL (B,D,G,H,I,M,N) SECAM (B,D,G,K,K1,L)</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Audio      Formats:MP3,WMA,MP2,OGG,AAC,M4A,MA4,FLAC,APE,3GP,WAV</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Power Voltage:100~240V 50/60Hz</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Built-in Speaker:8Ω,1.5W x1(SRS Sound      Technology)</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Compatible with Phone, Computer,Laptop, PC,      Tablet PC, Xbox</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Product size:12.7*8.15*4.85cm</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Portable Power Source: Mobile      Power(9V,2A)</span></p>  <p><img src=\"https://ae01.alicdn.com/kf/Hbd5fc45bfa4d4ecd8d0b4129a98fcc81D.webp\" slate-data-type=\"image\"></p>  <p><img src=\"https://ae01.alicdn.com/kf/Hd0e38f74cff24e81a73908d1040e81d9A.webp\" slate-data-type=\"image\"></p>  <p><img width=\"944\" height=\"944\" src=\"https://ae01.alicdn.com/kf/H7fdb326557ce4d6a8c2df9d4e87c076fE.webp\"      slate-data-type=\"image\"></p>  <p style=\"font-family:&quot;Open Sans&quot;, Roboto, Arial, Helvetica, sans-serif, SimSun;font-size:14px;font-weight:bold;letter-spacing:normal;line-height:inherit;text-align:start;white-space:normal;color:rgb(0, 0, 0);background-color:rgb(255, 255, 255);margin:0px;margin-bottom:0px;margin-top:0px;margin-left:0px;margin-right:0px;padding:0px;padding-bottom:0px;padding-top:0px;padding-left:0px;padding-right:0px;box-sizing:border-box\"    class=\"descTitle\" align=\"start\"><span      style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Portable&nbsp;Charging</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Support 9V-2A mobile power supply with Type      C, external mobile power supply can be viewed anywhere in unlimited time</span><span      style=\"color:rgb(244, 78, 59);font-size:18px;font-family:arial, helvetica, sans-serif\">(Note: It is recommended      that the power interface and the type-c interface do not supply power to the projector at the same time! )</span>  </p>  <p><img width=\"941\" height=\"1376\" src=\"https://ae01.alicdn.com/kf/S5f2270f51be6433b9b6ba0605d0f365fv.webp\"      slate-data-type=\"image\"></p>  <p><img width=\"935\" height=\"1628\" src=\"https://ae01.alicdn.com/kf/Scc535cf9cd6348338aec7fb8067a27e8u.webp\"      slate-data-type=\"image\"></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">30,000 hours of high quality light source      beads and long life</span></p>  <p><img src=\"https://ae01.alicdn.com/kf/H5eae2f26a0654f75afdd52f946320681x.webp\" slate-data-type=\"image\"><strong><span        style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Man reflection image Diffuse reflection        image</span></strong></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Diffuse reflection image,non-light ray,lion      eyelid LED light sourcelong-time viewing not easy fatigue 30000+ small life, several years available</span><img      src=\"https://ae01.alicdn.com/kf/H4f240033ae41430d8b3f9d33ecd326358.webp\" slate-data-type=\"image\"><span      style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">HDR high dynamic display technology brings better      contrast between light and dark, showing a more natural,realistic and vivid picture, allowing users to see more      details.</span><img src=\"https://ae01.alicdn.com/kf/H117b1bb5bf6548669575d439171cecfdo.webp\"      slate-data-type=\"image\"><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">A new generation of      constant temperature fan design ensures stable operation of the system.</span><img      src=\"https://ae01.alicdn.com/kf/H1eec1235896c40fcb2b4aa3d85a9886cS.webp\" slate-data-type=\"image\"><span      style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Built-in speaker. Independent speaker cavity      design</span><img src=\"https://ae01.alicdn.com/kf/H0fc9452d0f094aadaa0190bb05a2d6c0g.webp\"      slate-data-type=\"image\"><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Five image      modes,easily choose the best projection for different content and environment</span><img      src=\"https://ae01.alicdn.com/kf/H282d7b9d5dfc4ed89173ef3792420af1a.webp\" slate-data-type=\"image\"><span      style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">It is more convenient to work with the same screen      via android/iphone to HDMI cable (</span><a href=\"https://www.aliexpress.com/item/1005002494034644.html?\"      target=\"_self\" class=\"\"><span        style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">https://www.aliexpress.com/item/1005002494034644.html?</span></a><span      style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">)</span></p>  <p><img width=\"944\" height=\"1430\" src=\"https://ae01.alicdn.com/kf/S9eed4edd5e1b40df88c1eb8d821852a2M.png\"      slate-data-type=\"image\"></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Small size,but allowing you to enjoy a big      screen anytime,anywhere</span></p>  <p><img src=\"https://ae01.alicdn.com/kf/H0fd42f8944dc49c18e5a56e5aedd1b3fr.webp\" slate-data-type=\"image\"></p>  <p><br></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">The mini projector is a best gift for      children to watch cartoons and videos, watch video with big screen,keeping children away from smartphones and      iPads,can protect children's eyes.</span></p>  <p><br></p>  <p><img src=\"https://ae01.alicdn.com/kf/H0015cf5953994f65ac55b5f84e69313ff.webp\" slate-data-type=\"image\"><strong><span        style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Play big screen games</span></strong></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Multiplayer game smooth and not stuck in big      screen games more than addiction</span></p>  <p><img src=\"https://ae01.alicdn.com/kf/H5d356bdb2fb4469588d0d14739c47c3dp.webp\" slate-data-type=\"image\"></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Multiple interfaces provide reliable      compatibility,compatible with Phone, Computer,Laptop, PC, Tablet PC, Xbox<br>,camera,game mechine,etc.</span><img      src=\"https://ae01.alicdn.com/kf/Sa4b5e60a0a0f46aeadfdbd8dcfa3bc105.webp\" slate-data-type=\"image\"></p>  <p><img src=\"https://ae01.alicdn.com/kf/Sbdd23ceedfa54f9f851c3171cc913ce9X.webp\" slate-data-type=\"image\"></p>  <p><br></p>  <p><img src=\"https://ae01.alicdn.com/kf/S1fab38036d1341da9658e32be27d4849Y.webp\" slate-data-type=\"image\"><img      src=\"https://ae01.alicdn.com/kf/H65c924c002d54b26b3d7cdbb55f656e05.webp\" slate-data-type=\"image\"><img      src=\"https://ae01.alicdn.com/kf/Sfe9043ba5e0f483392a8aed528974d387.png\" slate-data-type=\"image\"></p>  <p><strong><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Package incluede:</span></strong></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Salange J9 projector x1;</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Remote control x1;</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">User manual x1;</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">Power cable x1;</span></p>  <p><span style=\"font-size:18px;font-family:arial, helvetica, sans-serif\">AV cable x1;</span></p>  <p><br></p>  <p><img src=\"https://ae01.alicdn.com/kf/H51277a744f1446e386163bc4b6d79540v.webp\" slate-data-type=\"image\"></p>  <p><br></p>  <p><img width=\"919\" height=\"919\" src=\"https://ae01.alicdn.com/kf/H69603260d2184ca18a1a36d383956808m.webp\"      slate-data-type=\"image\"></p>  <p><img src=\"https://ae01.alicdn.com/kf/H6539e07fdb32498baecdd275460a06a0E.webp\" slate-data-type=\"image\"><img      src=\"https://ae01.alicdn.com/kf/H6d1c5094f04c41e5b702983ed77a1878U.webp\" slate-data-type=\"image\"></p>  <p>    <kse:widget data-widget-type=\"customText\" id=\"23506988\" type=\"relation\"></kse:widget><br>  </p></div>",
    "categories": [
      {
        "name": "Trending",
        "id": "trending"
      },
      {
        "name": "Electronics & Computers",
        "id": "electronics-computers"
      }
    ],
    "tags": [
      "led",
      "projector"
    ],
    "images": {
      "big": [
        "salange-mini-led-portable-projector-0.webp",
        "salange-mini-led-portable-projector-1.webp",
        "salange-mini-led-portable-projector-2.webp",
        "salange-mini-led-portable-projector-3.webp"
      ],
      "small": [
        "salange-mini-led-portable-projector-0-thumb.webp",
        "salange-mini-led-portable-projector-1-thumb.webp",
        "salange-mini-led-portable-projector-2-thumb.webp",
        "salange-mini-led-portable-projector-3-thumb.webp"
      ]
    },
    "seo": {
      "title": "Salange Mini LED Portable Projector",
      "description": "Salange Mini LED Portable Projector"
    },
    "shipping": {
      "standard": {
        "cost": 7.5,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 14
      },
      "express": {
        "cost": 30.75,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 5
      }
    },
    "total": 1
  },
  {
    "name": "Stainless Steel Leather Bracelet Men's",
    "id": "stainless-steel-leather-bracelet-mens",
    "stock": 10,
    "actual price": 7.69,
    "price": 13.45,
    "rrp": 19.23,
    "topBanner": null,
    "popular now": "true",
    "item": "Stainless Steel Leather Bracelet Men's",
    "description": null,
    "descriptionHtmlSort": null,
    "descriptionHtmlLong": null,
    "categories": [],
    "tags": [],
    "images": {
      "big": [
        "stainless-steel-leather-bracelet-mens-0.webp",
        "stainless-steel-leather-bracelet-mens-1.webp",
        "stainless-steel-leather-bracelet-mens-2.webp",
        "stainless-steel-leather-bracelet-mens-3.webp",
        "stainless-steel-leather-bracelet-mens-4.webp"
      ],
      "small": [
        "stainless-steel-leather-bracelet-mens-0-thumb.webp",
        "stainless-steel-leather-bracelet-mens-1-thumb.webp",
        "stainless-steel-leather-bracelet-mens-2-thumb.webp",
        "stainless-steel-leather-bracelet-mens-3-thumb.webp",
        "stainless-steel-leather-bracelet-mens-4-thumb.webp"
      ]
    },
    "seo": {
      "title": null,
      "description": null
    },
    "shipping": {
      "standard": {
        "cost": 9.5,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 30
      },
      "express": {
        "cost": 15.6,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 12
      }
    },
    "total": 1
  },
  {
    "name": "Portable Handheld Wireless Car Vacuum Cleaner",
    "id": "portable-handheld-wireless-car-vacuum-cleaner",
    "stock": 500,
    "actual price": 30.5,
    "price": 53.37,
    "rrp": 101.4,
    "topBanner": null,
    "popular now": "true",
    "item": "Portable Handheld Wireless Car Vacuum Cleaner",
    "description": "Magic Flying Ball Pro Spinner Toys Hand Controlled Boomerang Mini Lighting Remote Control Drone For Adults Kids interaction Gift",
    "descriptionHtmlSort": "<div>\n  <p >Xiaomi Portable Car Vacuum Cleaner Handheld Vacuum Cleaner Car Home Dual-purpose Wireless Dust Catcher 20000PA Cyclone Suction\n\n</p>\n</div>",
    "descriptionHtmlLong": null,
    "categories": [
      {
        "name": "Home & Kitchen",
        "id": "home-kitchen"
      },
      {
        "name": "Cleaning supplies",
        "id": "cleaning-supplies"
      }
    ],
    "tags": [
      "vacuum",
      "cleaner",
      "wireless",
      "car"
    ],
    "images": {
      "big": [
        "portable-handheld-wireless-car-vacuum-cleaner-0.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-1.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-2.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-3.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-4.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-5.webp"
      ],
      "small": [
        "portable-handheld-wireless-car-vacuum-cleaner-0-thumb.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-1-thumb.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-2-thumb.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-3-thumb.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-4-thumb.webp",
        "portable-handheld-wireless-car-vacuum-cleaner-5-thumb.webp"
      ]
    },
    "seo": {
      "title": "Xiaomi Portable Car Vacuum Cleaner Handheld Vacuum Cleaner Car Home Dual-purpose Wireless Dust Catcher 20000PA Cyclone Suction",
      "description": "Xiaomi Portable Car Vacuum Cleaner Handheld Vacuum Cleaner Car Home Dual-purpose Wireless Dust Catcher 20000PA Cyclone Suction"
    },
    "shipping": {
      "standard": {
        "cost": null,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 18
      },
      "express": {
        "cost": 15,
        "description": "",
        "approxTimeDetail": "",
        "estimatedDays": 13
      }
    },
    "total": 1
  }
]


const DummyTransactionDetails = {
  id: "klasdfklj99224334",
  update_time: "93939333939",
  purchase_units: [
    {
      shipping: {
        address: "Some address here"
      }
    }
  ],
  payer: {
    name: {
      given_name: "John",
      surname: "Smith"
    }
  }
}

const useDummy = false;


const PaymentSuccess = (props) => {

  const { goondrookData, updateAllCartItems, allCartItems } = useGoondrookSiteData();
  const obj = {
    totalAmountOnInvoice: 0,
    transactionDetails: useDummy ? DummyTransactionDetails : undefined,
    shippingCharge: 0,
    purchasedItems: useDummy ? allCartItems : undefined
  }
  const [ppObjects, setPpObjects] = useState(obj);



  useEffect(() => {

    if (props.location.state) {
      const { transactionDetails, allCartItems, shippingCharge, totalAmount } = props.location.state;
      if (transactionDetails !== DummyTransactionDetails) {
        const tempObj = {
          totalAmountOnInvoice: totalAmount,
          transactionDetails: transactionDetails,
          shippingCharge: shippingCharge,
          purchasedItems: allCartItems
        }
        setPpObjects(tempObj);
        setTimeout(() => {
          updateAllCartItems([]);
          document.getElementById("cart-item-count").innerHTML = "0";
        }, 1000)

      } else {
        props.history.push("/notfound")
      }

    } else {
      props.history.push("/notfound")
    }
    window.scroll(0, 0);
  }, [])



  const { totalAmountOnInvoice, transactionDetails, shippingCharge, purchasedItems } = ppObjects;

  if (!transactionDetails) return null;

  if (!transactionDetails && !purchasedItems) return (<Redirect to="/notfound" />);



  const address = transactionDetails.purchase_units[0].shipping.address;

  const addressA = address.address_line_1;
  const addressB = address.admin_area_1;
  const addressC = address.admin_area_2;
  const postCode = address.postal_code;
  const country = address.country_code;

  const payerGivenName = transactionDetails.payer.name.give_name;
  const payerSurname = transactionDetails.payer.name.surname;

  let dateTime = new Date(transactionDetails.update_time).toLocaleString();

  const currencySign = goondrookData.config.currencySign;



  return (
    <Page
      id="payment-success"
    >

      <div className="payment-success">

        <div className="ps-summary">

          <div className="ps-head">

            <div>
              <svg width="24" height="24" aria-hidden="true" focusable="false" fillRule="evenodd" clipRule="evenodd">>
                <use xlinkHref="#icon-tick-in-circle" />
              </svg>
            </div>

            <div className="ps-head__txt">
              <h2>Thank you for the purchase.</h2>
              <p>
                You have successfully made a payment of <strong>{currencySign}{totalAmountOnInvoice}</strong>
              </p>
            </div>

          </div>
        </div>


        <div className="ps-summary">

          <div className="summary-fees">

            <div className="summary-fees__item">
              <p className="headitem">Date </p>
              <p style={{ textAlign: 'right' }}>{dateTime}</p>
            </div>


            <div className="summary-fees__item">
              <p className="headitem">Invoice number </p>
              <p style={{ textAlign: 'right' }}>{transactionDetails.id}</p>
            </div>

            <div className="summary-fees__item">
              <p className="headitem">Payment method</p>
              <p style={{ textAlign: 'right' }}>Paypal</p>
            </div>

            <hr></hr>

            <div className="summary-fees__item">
              <span className="subtotal"><h3>Items</h3></span>
              <span className="subtotal">

              </span>
            </div>

            {purchasedItems &&
              purchasedItems.map((item, i) => {
                const variantType = item.selectedVariant ? " (" + item.selectedVariant.name + ")" : "";
                return (
                  <div key={i} className="summary-fees__item-with-count">
                    <span>{item.name + variantType}</span>
                    <span>{item.total}x</span>
                    <span>{currencySign}{(item.price * item.total).toFixed(2)}</span>
                  </div>
                )
              })
            }

            <hr></hr>

            {shippingCharge > 0 &&
              <div className="summary-fees__item">
                <span className="subtotal">Shipping:</span>
                <span className="subtotal">{currencySign}{shippingCharge}</span>
              </div>
            }
            {/*}
              <div className="summary-fees__item">
                <span className="subtotal">Shipping:</span>
                <span className="subtotal">${totalShippingCost ? totalShippingCost : standardShippingCost}</span>
              </div> */}

            <div className="summary-fees__item">
              <span className="total">Total:</span>
              <span className="total">{currencySign}{ppObjects.totalAmountOnInvoice}</span>
            </div>


            <hr></hr>
            <br></br>
            <div className="summary-fees__item">
              <div className="shipto">
                <p className="headitem">Shipping address </p>

                <div className="add">
                  <p>{payerGivenName} {payerSurname}</p>
                  <p>{addressA}</p>
                  <p>{addressC}, {addressB}, {postCode}</p>
                  <p>{country}</p>
                </div>

              </div>
            </div>
          </div>


          <div className="ps-box">
            <p style={{ fontWeight: 700 }}>What happens now</p>
            <p>Upon payment approval you will recieve a payment confirmation email from PayPal. You will also receive your order summary and invoice from Goondrook in your email.</p>
            <p>A shipping confirmation will be emailed to you once your order has been shipped. </p>
            <p>Please contact us at <span><Link to="/help">help</Link></span> for any inquiry.</p>
          </div>

        </div>

      </div>

    </Page>
  );

}


export default withRouter(PaymentSuccess);
